import { ENDPOINTS } from '../../network/endpoints';

/** @implements {import('../../../contracts/IPhonenumbersRepository').IPhonenumbersRepository} */
export class PhonenumbersRepository {
  /** @param {import('../../../contracts/IHttpClient').IHttpClient} client */
  constructor(client) {
    this.client = client;
  }

  async getPhoneNumbers(options = {}) {
    return this.client.get(ENDPOINTS.PHONE_NUMBERS.BASE, {
      params: options,
    });
  }

  async createPhoneNumber(phoneNumberData) {
    return this.client.post(ENDPOINTS.PHONE_NUMBERS.BASE, phoneNumberData);
  }

  async getPhoneNumberById(phoneNumberId) {
    return this.client.get(ENDPOINTS.PHONE_NUMBERS.BY_ID(phoneNumberId));
  }

  async updatePhoneNumber(phoneNumberId, updateData) {
    return this.client.patch(ENDPOINTS.PHONE_NUMBERS.BY_ID(phoneNumberId), updateData);
  }

  async deletePhoneNumber(phoneNumberId) {
    return this.client.delete(ENDPOINTS.PHONE_NUMBERS.BY_ID(phoneNumberId));
  }
}
